import { resolveServiceUrl } from '../../api/api-config';
import { createApiClient } from '../../api/create-api-client';
import getAuditLogFilters from './get-audit-log-filters/get-audit-log-filters';
import getAuditLogs from './get-audit-logs/get-audit-logs';

const client = createApiClient({ uri: resolveServiceUrl('AUDIT_LOGS_URL') });

const auditLogsService = {
  getAuditLogs: getAuditLogs(client),
  getAuditLogFilters: getAuditLogFilters(client),
};

export default auditLogsService;
